export enum TimesheetSettlementType {
  OneMonth = 0,
  TwoMonths = 1,
  ThreeMonths = 2,
  FourMonths = 3,
}
